<template>
    <div>
        <div class="top_banner" :class="news_class[newsType]">
            <div class="top_banner_text">
                <p>{{news_type[newsType]}}</p>
                <!--<p>News</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="news_details clearfix">
                    <div class="news_details_left">
                        <h1 class="new_de_title">{{new_data.newsTitle}}</h1>
                        <p class="new_de_time">发布时间：<span class="time">{{new_data.createDate}}</span> | 作者：<span
                                class="source">{{new_data.createBy}}</span></p>
                        <p class="new_de_line"></p>
                        <div class="ql-container ql-snow" style="border: none">
                            <div class="ql-editor">
                                <div class="new_de_content" v-html="new_data.newsTextContent">
                                </div>
                            </div>
                        </div>
                        <div class="new_de_choose clearfix">
                            <div class="new_de_choose_left">
                                <p class="prev" @click="prev"><span>上一篇：</span>{{prev_test || '无'}}</p>
                                <p class="next" @click="next"><span>下一篇：</span>{{next_test || '无'}}</p>
                            </div>
                            <div class="new_de_choose_right" @click="fun()">
                                <a href="javascript:;" class="reback">返回</a>
                            </div>
                        </div>
                    </div>
                    <div class="news_details_right">
                        <!--新增搜索框-->
<!--                        <div class="search_box search_box_diff clearfix">-->
<!--                            <input type="text" placeholder="请输入新闻关键词" maxlength="32">-->
<!--                            <img src="@/assets/img/icon_search.png" alt="" style="top:4px;">-->
<!--                        </div>-->
                        <div class="new_de_right_top">
                            <p class="active" data-type="2">公司新闻</p>
                            <p data-type="3" @click="$router.push({path: '/news/newsHy/3'})">行业动态</p>
                            <p data-type="4" @click="$router.push({path: '/news/newsHy/4'})">政策法规</p>
                        </div>
                        <div class="new_de_right_btm">
                            <p class="title">热门文章</p>
                            <div class="recommend" v-for="(item,index) in query_data" :key="index" @click="_query_data(item)">
                                <p class="article">
                                    {{item.newsTitle}}
                                </p>
                                <p class="time">{{item.updateDate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "news_details",
        data() {
            return {
                newsType: this.$route.params.newsType,
                newsId: this.$route.params.newsId,
                news_type: {
                    2: '公司新闻',
                    3: '行业动态',
                    4: '政策法规',
                    6: '合同百科',
                    7: '法律知识',
                },
                news_class: {
                    2: 'top_banner_text_2',
                    3: 'top_banner_text_3',
                    4: 'top_banner_text_4',
                    6: 'top_banner_text_6',
                    7: 'top_banner_text_7',
                },
                new_data: {},
                query_data: {},
                prev_test: '',
                next_test: '',
                prev_id: '',
                next_id: '',
            }
        },
        created() {
            this.get_data()
            this.get_query()
            this.get_queryPage()
        },
        methods: {
            get_data() {
                document.querySelector('#app').scrollTop =0
                this.$SIF.httpGet({
                    url: this.$SIF._serve.menhu + "/news/getMenhuNotice/" + this.newsId,
                    succFun: res => {
                        this.new_data = res.data
                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_query() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/news/query",
                    data: {
                        newsType: this.newsType,
                        status: 0
                    },
                    succFun: res => {
                        var as = res.data.list
                        for (var i = 0; i < as.length; i++) {
                            if (as[i].id == this.newsId) {
                                if (i > 0) {
                                    this.prev_test = as[i - 1].newsTitle
                                    this.prev_id = as[i - 1].id
                                } else {
                                    this.prev_test = '无'
                                }
                                if (i < as.length - 1) {
                                    this.next_test = as[i + 1].newsTitle
                                    this.next_id = as[i + 1].id
                                } else {
                                    this.next_test = '无'
                                }
                            }
                        }
                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_queryPage() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/news/queryPage",
                    data: {
                        entity: {
                            newsType: this.newsType,
                            status: 0,
                            isHotNews: true
                        },
                        pageBean: {
                            pageNum: 1,
                            pageSize: 5
                        }
                    },
                    succFun: res => {
                        this.query_data = res.data.list
                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            prev() {
                if( this.prev_id){
                    this.newsId = this.prev_id
                    this.get_data()
                    this.get_query()
                }else {
                    this.$message({
                        message: '已经是第一条信息了',
                        type: 'warning'
                    });
                }

            },
            next() {
                if(this.next_id){
                    this.newsId = this.next_id
                    this.get_data()
                    this.get_query()
                }else {
                    this.$message({
                        message: '没有更多数据了',
                        type: 'warning'
                    });
                }

            },
            _query_data(item){
                this.newsId = item.id
                this.get_data()
            },
            fun() {
                this.$router.go(-1); //返回上一层
            },
        }
    }
</script>

<style scoped>
    .top_banner_text_2 {
        background-image: url(~@/assets/img/banner/news_banner.png);
        background-size: 100% 100%;
    }

    .top_banner_text_3 {
        background-image: url(~@/assets/img/banner/newsHy_banner.png);
        background-size: 100% 100%;
    }

    .top_banner_text_4 {
        background-image: url(~@/assets/img/banner/head_bar_contract.png);
        background-size: 100% 100%;
    }

    .top_banner_text_6 {
        background-image: url(~@/assets/img/banner/head_bar_law.png);
        background-size: 100% 100%;
    }

    .top_banner_text_7 {
        background-image: url(~@/assets/img/banner/lawIssue_banner.png);
        background-size: 100% 100%;
    }
    .article , .new_de_right_top ,.new_de_choose_left{
        cursor: pointer;
    }
    .article:hover,.new_de_right_top:hover,.new_de_choose_left:hover{
        color: #19bc73;

    }
</style>